import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { TRANSLATIONS, SUPPORTED_LANGUAGES } from "../i18n/translations";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div className={`flex items-center gap-1.5 ${compact ? "" : "px-2"}`}>
      <Globe className="w-4 h-4 text-[#52796F]" />
      <select
        data-testid="ui-language-switcher"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="bg-transparent text-sm font-semibold text-[#1B4332] focus:outline-none cursor-pointer"
        aria-label="Change UI language"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l} value={l}>
            {TRANSLATIONS[l]?.[`lang.${l}`] || l}
          </option>
        ))}
      </select>
    </div>
  );
};
